import { H1 } from '@alto/design-system';
import React from 'react';
import { PageBackground } from '~web/components/Page';

export const NoMatch: React.FC = () => {
  return (
    <PageBackground>
      <div>
        <H1 center>The page you are looking for doesn’t exist.</H1>
      </div>
    </PageBackground>
  );
};
